import React, { Component } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

class PDFGenerator extends Component {
  generatePDF = () => {
    const { data } = this.props;
    const{pdfName} = this.props;

    
    const pdf_name = this.props.pdfName + '.pdf'

    // Create a new PDF document
    const doc = new jsPDF();

    const header = 'Page Header';

    // Define the column headers
    const headers = Object.keys(data[0]);

    // Define the data to be populated in the PDF
    const tableData = data.map((item) => headers.map((key) => item[key]));

    // Set the position for the table
    const tableX = 10;
    const tableY = 10;

     let y = 20; // Adjust the starting point to leave space for the header

    // Set the border style for the table (optional)
    doc.setDrawColor(0); // Black color
    doc.setLineWidth(0.1); // 0.1mm border width

    // Add the page header to each page
    doc.text(8, 8, header);

    // Loop through the data and draw the table
    for (let i = 0; i < data.length; i++) {
      const row = data[i];
      let x = 10;

      for (let j = 0; j < row.length; j++) {
        // Draw cell border
        doc.rect(x, y, 50, 10); // Adjust cell width and height as needed

        // Add cell content
        doc.text(row[j], x + 2, y + 7);

        x += 50; // Adjust cell width as needed
      }

      y += 10; // Adjust cell height as needed
    }

    // Add a table to the PDF using jspdf-autotable
    doc.autoTable({
      head: [headers],
      body: tableData,
      startY: tableY,
    });

    // Save or display the PDF
    doc.save(pdf_name);
  };

  render() {
    return (
      
        <button className="btn btn-secondary"  style={{
                      marginBottom: 20,
                      marginTop: 10,
                      paddingTop: 5,
                      paddingBottom: 5,
                      paddingLeft: 26,
                      paddingRight: 26,
                      fontWeight: "bold",
                    }} onClick={this.generatePDF}>Generate PDF</button>

          );
  }
}

export default PDFGenerator;
